import { Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IPaymentErrorDialogProps {
	open: boolean;
	errorMessage: string;
	onClose: () => void;
}

const PaymentErrorDialog = ({ open, errorMessage, onClose }: IPaymentErrorDialogProps) => {
	const { t } = useTranslation();

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			disableEscapeKeyDown
			slotProps={{
				backdrop: {
					onClick: undefined,
				},
			}}
		>
			<DialogContent sx={{ padding: 3 }}>
				<Typography variant="h6" gutterBottom>
					{t("paymentPage.linkpay.failedTitle")}
				</Typography>
				<Typography variant="body1" color="text.secondary">
					{errorMessage}
				</Typography>
			</DialogContent>
			<DialogActions sx={{ padding: 3, paddingTop: 1 }}>
				<Button
					onClick={onClose}
					variant="contained"
					fullWidth
					data-testid="payment-error-ok-button"
					sx={{
						backgroundColor: "#ff5733",
						"&:hover": {
							backgroundColor: "#e54a2e",
						},
					}}
				>
					{t("Generic.ok")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PaymentErrorDialog;
